var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c420bd41152922c06c3ef3f97e5ca5773bd4da33"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["eskolare-next@eskolare"]={id:"c420bd41152922c06c3ef3f97e5ca5773bd4da33"};
      